import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  RiskMapHistoryLogGQL,
  RiskMapHistoryLogQuery,
  RiskMapTreeQueryComplexInput,
  PageInput,
  PagingInput,
  RiskMapTreeSimpleQueryInput,
  OperatorInput,
  RiskMapTreeColumns,
  ComparatorOperators,
  OrderTypeInput,
  RiskMapTreeSimpleInput
} from '../../../graphql/generated';
import { param } from 'cypress/types/jquery';

@Injectable({
  providedIn: 'root'
})
export class HistoryLogService {
  private readonly riskMapHistoryLogGQL = inject(RiskMapHistoryLogGQL);

  /**
   * Fetches history log data for risk maps
   * 
   * @param filters The filters to apply to the history log query
   * @param legalEntityId The legal entity ID
   * @param campaignId The campaign ID
   * @param page The pagination information
   * @returns An observable of the history log data
   */
  fetchRiskMapHistoryLog(
    parametrs: any,
    legalEntityId: string,
    campaignId: string
  ): Observable<RiskMapHistoryLogQuery['riskMapHistoryLog']> {
    const params = convertLazyLoadToComplexWithoutPageCptTree(parametrs)
    return this.riskMapHistoryLogGQL.fetch({ filters: params.query, legalEntityId, campaignId, page: params.page }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.riskMapHistoryLog));
  }
}


export function convertLazyLoadToComplexWithoutPageCptTree(parameters: any): { query: RiskMapTreeQueryComplexInput, page: PagingInput } {
  // const query: { [key: string]: RiskMapTreeSimpleQueryInput[] } = {};
  const querySearch: RiskMapTreeSimpleQueryInput[] = [];
  // if (parameters) {

  //   if (parameters.filters) {

  //     Object.entries(parameters.filters).forEach(([field, values]) => {
  //       //console.log"value", values);

  //       if (values !== null && Array.isArray(values) && values.length > 0) {
  //         (ENUM_CPT_TREE[field as keyof typeof ENUM_CPT_TREE] || [field]).forEach(key => {
  //           if (!query[field]) {
  //             query[field] = [];
  //           }
  //           query[field].push({
  //             field: key as RiskMapTreeColumns,
  //             filters: {
  //               operator: ComparatorOperators.Match,
  //               value: values
  //             }
  //           });
  //         })
  //       }
  //     });
  //   }
  // }

  const querySend: RiskMapTreeSimpleInput[] = [];

  if (parameters?.search && parameters.search !== '') {
    Object.keys(ENUM_CPT_TREE).forEach(key => {
      if (key !== 'orderId') {
        (ENUM_CPT_TREE[key as keyof typeof ENUM_CPT_TREE] || [key])?.forEach(key => {
          querySearch.push({
            field: key as RiskMapTreeColumns,
            filters: {
              operator: ComparatorOperators.Contains,
              value: parameters.search
            }
          });
        });
      }
    })
    querySend.push({
      operator: OperatorInput.Or,
      query: querySearch
    })
  }


  return {
    query: {
      operator: OperatorInput.And,
      query: querySend
    },
    page: {
      pageNo: parameters?.page ?? 0,
      pageSize: parameters?.rows ?? 10000
    }
  }
}

export const ENUM_CPT_TREE = {
  lastUpdatedBy: [RiskMapTreeColumns.RiskMapLastUpdatedBy],
  lastUpdatedAt: [RiskMapTreeColumns.RiskMapLastUpdatedAt],
  legalEntityName: [RiskMapTreeColumns.LegalEntityName],
  legalEntityCode: [RiskMapTreeColumns.LegalEntityCode],
  code: [RiskMapTreeColumns.Code],
  name: [RiskMapTreeColumns.Name]
}